import {IOrganization} from "./organization.model";
import {IEmployee} from "./employee.model";

export interface ISetting {
  id?: number;
  title?: string;
  type?: string;
  part?: string;
  add_auto_project?: any;
  linear_chart_orders?: any;
  linear_chart_customers?: any;
  bar_chart_customers?: any;
  bar_chart_orders?: any;
  summary_list_customers?: any;
  summary_list_orders?: any;
  most_order_customers?: any;
  most_order_kala?: any;
  stock_order_point?: any;
  stock_alarm_point?: any;
  forgotten_customers?: any;
  marketing_step?: any;
  open_ticket?: any;
  new_ticket?: any;
  employee_str?: any;
  my_open_transaction?: any;
  open_transaction_top_level?: any;
  expired_transaction?: any;
  no_follow_up_cycle?: any;
  dash_step1_title?: string;
  dash_step2_title?: string;
  dash_step3_title?: string;
  dash_step4_title?: string;
  status?: string;
  showticket?: string;
  description?: string;
  my_last_action?: any;
  my_transaction?: any;
  my_calendar?: any;
  my_event?: any;
  my_meeting?: any;
  speed_access?: any;
  feat_show_ticket?: any;
  feat_show_store?: any;
  feat_show_support?: any;
  feat_show_voip?: any;
  feat_show_project_mng?: any;
  feat_show_accounting?: any;
  feat_show_sms?: any;
  feat_show_setting?: any;
  feat_show_sales_param?: any;
  feat_client_manager_show?: any;
  feat_assign_customer_user?: any;
  feat_show_project_phase_progress?: any;
  feat_show_project_factor_add?: any;
  feat_transaction_description_required?: any;
  organization?: IOrganization;
  employee?: IEmployee;

}


export class Setting implements ISetting {
  constructor(public id?: number, public itemName?: string, public status?: string
    , public organization?: IOrganization) {
  }
}
